import { RatingGaugeTheme, styles, variants } from '../RatingGaugeStyles.css';

import { baseTheme } from './RatingGaugeBaseTheme.css';
import { multiVariantStyles } from './RatingGaugeVariants.css';

/*******************
 * Theme
 *******************/

const RatingGaugeStableTheme: RatingGaugeTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { RatingGaugeStableTheme };
